// extracted by mini-css-extract-plugin
export var fadeIn = "_98-0";
export var panelInner = "_98-2";
export var panelOuter = "_98-1";